import React from 'react';
import { Route } from 'react-router-dom';
import { createLazyRoute } from '@core/router';

const profilePageRoute = () => import('./ProfilePage');

const profileRoutes = <Route path="/profile" {...createLazyRoute(profilePageRoute, m => m.default)} />;

export default profileRoutes;
